import { render, staticRenderFns } from "./giftCouponPropertyPool.vue?vue&type=template&id=11b32db1"
import script from "./giftCouponPropertyPool.vue?vue&type=script&lang=js"
export * from "./giftCouponPropertyPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports